import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createVehicleCategory,
  deleteVehicleCategory,
  getVehicleCategories,
  getVehicleCategoryById,
  updateVehicleCategory,
} from "./vehicle-category.service";

export const useGetVehicleCategories = () => {
  return useQuery({
    queryKey: ["vehicle-categories"],
    queryFn: getVehicleCategories,
  });
};

export const useGetVehicleCategoryById = (categoryId) => {
  return useQuery({
    queryKey: ["vehicle-categories", categoryId],
    queryFn: () => getVehicleCategoryById(categoryId),
    enabled: Boolean(categoryId),
  });
};

export const useCreateVehicleCategoryMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createVehicleCategory,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vehicle-categories"] });
    },
  });
};

export const useUpdateVehicleCategoryMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ categoryId, categoryData }) => updateVehicleCategory(categoryId, categoryData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vehicle-categories"] });
    },
  });
};

export const useDeleteVehicleCategoryMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteVehicleCategory,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vehicle-categories"] });
    },
  });
};
